import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { TriangleWarning } from 'src/easyclaim.app.assets/icons/TriangleWarning';
import FormattedHtmlMessage from 'src/easyclaim.app.components/common/FormattedHtmlMessage';
import { TimeoutIcon } from 'src/easyclaim.app.components/common/ImageRepository';
import styled from 'styled-components';

import { CenteredCircle, DetailContainer } from '../easyclaim.app.components/index';
import theme from '../easyclaim.app.theme/theme';

import { ScreenComponent } from './ScreenComponent';

export class Timeout extends ScreenComponent<AppState, {}> {
	constructor(props: AppState) {
		super(props);
	}

	public render() {
		return (
			<div className="main-container">
				<Centered>
					<CenteredCircle className="timeout-triangle-warning" borderStyle="none">
						<TriangleWarning />
					</CenteredCircle>
					<h2 className="timeout-title">
						<FormattedHtmlMessage id="timeout.headline.first" />
					</h2>
					<h4 className="timeout-paragraph">
						<FormattedHtmlMessage id="timeout.paragraph.first" />
					</h4>
					<p className="timeout-container word-break-auto">
						<FormattedMessage id="timeout.paragraph.first" />
					</p>
				</Centered>
				<DetailContainer>
					<CenteredCircle
						className="timeout-icon-circle"
						size="6rem"
						borderColor={
							this.props.easyClaimCase?._configuration?.successColor
								? this.props.easyClaimCase._configuration.successColor
								: theme.colors.success
						}
						borderStyle="solid"
						borderWidth="3px"
					>
						<TimeoutIcon />
					</CenteredCircle>
				</DetailContainer>
				<Centered>
					<p style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
						<FormattedMessage id="timeout.bottom" />
					</p>
				</Centered>
			</div>
		);
	}
}

const Centered = styled.div`
	margin: 2rem auto;
`;
